"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';
//# sourceMappingURL=getDisplayName.js.map